type Id = number | string;
type LeafType = {
  id: Id,
  order: number,
  title: string,
  leafs: LeafType[],
}

export default class TreeNode {
  id?: Id;

  title?: string;

  order?: number;

  leafs: TreeNode[] = [];

  static create(leaf: LeafType): TreeNode {
    const n = new TreeNode();

    n.id = leaf.id;
    n.order = leaf.order || 0;
    n.title = leaf.title;
    n.leafs = leaf.leafs.map((child, order) => TreeNode.create({
      ...child,
      order: child.order || order,
    }));

    return n;
  }

  up(order: number) {
    if (order < 1 || order >= this.leafs.length) return;

    const nodeIndex = this.leafs.findIndex((leaf) => leaf.order === order);
    const swapNodeIndex = this.leafs.findIndex((leaf) => leaf.order === order - 1);

    // Swap nodes
    const node = this.leafs[nodeIndex];
    const swapNode = this.leafs[swapNodeIndex];

    this.leafs[nodeIndex] = this.leafs[swapNodeIndex];
    this.leafs[swapNodeIndex] = node;

    // Swap orders i.e. node.order <-> swapNode.order
    node.order = swapNode.order;
    swapNode.order = order;
  }

  down(childIndex: number) {
    this.up(childIndex + 1);
  }
}
